<ng-container *ngIf="!editMode; else editTemplate">
	{{ getDisplayRole(selectedRole) }}
</ng-container>

<ng-template #editTemplate>
	<form [formGroup]="roleForm">
		<mat-select formControlName="roleFormControl" (selectionChange)="onRoleChange($event, params.data)">
			<!-- Add a default option to display the current value if it's not in the dropdown -->
			<mat-option *ngIf="!isRoleInOptions(selectedRole)" [value]="selectedRole" disabled>
				{{ getDisplayRole(selectedRole) }}
			</mat-option>
			<mat-option *ngFor="let role of roleOptions" [value]="role.value">
				{{ role.viewValue }}
			</mat-option>
		</mat-select>
	</form>
</ng-template>